export enum PartitionTypeText {
  Photo = "Photo",
  Video = "Video",
  Text = "Text",
  Phone = "Phone",
  SocialMedia = "SocialMedia",
  Gallery = "Gallery",
  Slider = "Slider",
}
